import { Account } from 'containers/Account'

export default Account
